import type { Schemas } from "#shopware";
import { ref } from "vue";

const _useProductGallery = () => {
  const medias = ref<
    Array<
      | {
          url: null | string;
          newTab: boolean;
          media: Schemas["Media"];
          apiAlias: "cms_image_slider_item";
        }
      | Schemas["ProductMedia"]
    >
  >([]);

  function addMedias(
    newMedias: Ref<
      Array<
        | {
            url: null | string;
            newTab: boolean;
            media: Schemas["Media"];
            apiAlias: "cms_image_slider_item";
          }
        | Schemas["ProductMedia"]
      >
    > = ref([])
  ) {
    medias.value = newMedias.value;
  }

  return {
    addMedias,
    medias,
  };
};

export const useProductGallery = createSharedComposable(_useProductGallery);
